/**
 * 新闻列表
 */

var ad = require('../modules/ad/ad');
var tools = require('tools');
var datetime = require('datetime');

if ($("#go_top").length > 0) {
    $(window).scroll(function() {
        if ($(window).scrollTop() > $(window).height()) {
            $("#go_top").fadeIn();
        } else {
            $("#go_top").fadeOut();
        }
    });    
}


var newslist = $('#newslist');

/**
 * 获取分页数据
 * @param  {[type]} thispage [description]
 * @return {[type]}          [description]
 */
function getdata(thispage, callback) {
	//newslist
	// body...
	$.ajax({
		url: siteurl + 'newslist/GetNewsListData',
		type: 'GET',
		dataType: 'json',
		data: {columnid: columnid, thispage: thispage},
	})
	.done(function(json) {
		callback(json);
	})
	.fail(function() {

	});
}

/**
 * 数据插入dom
 * @param  {[type]} json [description]
 * @return {[type]}      [description]
 */
function datainsert(json) {
	if (json.length < 20) {
		dataover = true;
	}
	var html = [];
	for (var i = 0; i < json.length; i++) {
		html.push('<li><a href="http://wap.eastmoney.com/3g/news/article,' + channelid + ',' + columnid + ',1,' + json[i].Code + '.shtml">' + json[i].Title + '</a><span class="time">' + datetime.dateFormat(new Date(parseInt(json[i].ReleaseTime.substr(6))),'M-d hh:mm') + '</span></li>');
	}
	newslist.append(html.join(''));
}

var dataover = false;
var thispage = 1;
var isloading = false;

function lazyload(){
	if (dataover) {
		return false;
	}
	if (isloading) {
		return false;
	}
	isloading = true;
	newslist_loading.html('<img src="' + siteurl + 'images/loading.gif"  />');
	thispage++;
	var timer1 = new Date();	
	getdata(thispage, function (json){
		var timer2 = new Date();
		if (timer2 - timer1 < 600) {
			setTimeout(function(){
				newslist_loading.html('');
				datainsert(json);
				isloading = false;				
			},600 - (timer2 - timer1));
		} else {
			newslist_loading.html('');
			datainsert(json);
			isloading = false;
		}
	});		

}

var newslist_loading = $('#newslist_loading');
/**
 * 第一次加载
 */
getdata(thispage, function (json){
	datainsert(json);

	setTimeout(function(){
		$(window).scroll(function() {
		    if($(window).scrollTop() >=  newslist_loading.offset().top - $(window).height() + 100) {
		       lazyload();
		    }
		});		
	},500);
});

var newslist_navswitch = $('#newslist_navswitch');
var newslist_colnav = $('#newslist_colnav');
var nav_open = false;
if ( $('a', newslist_colnav).length > 3 ) {
	newslist_navswitch.css({display:'block'});
	newslist_navswitch.click(function (){
		if ( nav_open ) {
			$('a:gt(2)', newslist_colnav).css({display:'none'});
			$('em', newslist_navswitch).attr('class','icon_nav_open');
			nav_open = false;
		}
		else{
			$('a', newslist_colnav).css({display:'inline-block'});
			$('em', newslist_navswitch).attr('class','icon_nav_close');
			nav_open = true;
		}
	});
}

$('a', newslist_colnav).each(function (){
	if( $(this).data('columnid') == columnid ){
		$(this).css({'font-weight':'bold'});
		if ( $(this).index() >= 3 ) {
			$('a', newslist_colnav).css({display:'inline-block'});
			$('em', newslist_navswitch).attr('class','icon_nav_close');		
			nav_open = true;	
		}
	}
});


/**
 * 广告
 */
if ( tools.getQueryString("coop_s") != "hejubao" ) {
	var topad = new ad({
		source : 'http://cp.eastmoney.com/wap/37.js',
		type : 'pagetop'
	});
	topad.show();

	var bottomad = new ad({
		source : 'http://cp.eastmoney.com/wap/91.js',
		type : 'pagebuttom_fix'
	});	
	bottomad.show();
}



//////////////////
// WEBPACK FOOTER
// ./dev/channel/newslist.js
// module id = 0
// module chunks = 14